<template>
  <!-- 注册 -->
  <div class="chongzhi">
    <Navbar :title="'账户余额'"></Navbar>
    <div class="top">
      <p class="title">账户余额</p>
      <div class="input-box">
        <span>¥ {{userInfo.user_account}}</span>
      </div>
    </div>
    <div class="bottom">
      <router-link to="/chongzhi" class="item">
        <van-icon class="icon" name="gold-coin-o" />
        <span>账户充值</span>
      </router-link>
      <router-link to="/tixian" class="item">
        <van-icon class="icon" name="after-sale" />
        <span>账户提现</span>
      </router-link>
      <router-link to="/zhuanzhang" class="item">
        <van-icon class="icon" name="cash-back-record" />
        <span>账户转账</span>
      </router-link>
      <router-link to="/bill" class="item">
        <van-icon class="icon" name="balance-list-o" />
        <span>账单日志</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import Tabber from "../components/Tabber";
import Navbar from "../components/Navbar";
// import websocket from '../utils/webSocket'
import { indexOp, uploadImg, updateOp, addOp, uploadFile } from "../api";
import base from "../api/base.js";
import { wechatConfig } from "../utils/wxConfig";
import { login } from "../utils/login_toast";
export default {
  components: {
    Navbar,
  },
  data() {
    return {
      money: "",
      jsApiParameters: "",
      userInfo: {
        id: "",
      },
      invate_uid:""
    };
  },
  created(){
    var invate_uid = this.$route.query.invate_uid;
    if(invate_uid){
      this.$cookies.set("invate_uid", invate_uid);
    }
    if (this.$cookies.isKey("userInfo")) {
      this.userInfo = this.$cookies.get("userInfo");
    }
    this.WXlogin()
    this.setShare()
  },
  methods: {
    //分享
    setShare() {
      const shareInfo = {
        title: `冷鲜柜网-账户余额`,
        desc: `聚制冷精英，集行业资源，方便您我他！`,
        link: base.shareURL + "/accountBalance?invate_uid=" + this.userInfo.id,
        img: "http://api.zglxgw.com/uploads/images/20201128/5fc1e41dbfbaf.jpg",
      };
      wechatConfig(shareInfo);
    },
    WXlogin() {
      var _this = this;
      var token = this.$cookies.get("Authorization");
      var code = this.getUrlKey("code");
      var state = this.getUrlKey("state");
      if (!token && code && state) {
        login(_this.getLoginUser);
      }else{
        this.getUser();
      }
    },
    getLoginUser(userInfo) {
      this.getUser();
      console.log(userInfo);
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    getUser() {
      var _this = this;
      var _this = this;
      _this.$toast.loading({
        message: "",
        forbidClick: true,
      });
      var api = "/user/show/1";
      indexOp(api).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          _this.$cookies.set("identity", res.data.identity);
          _this.$cookies.set("userInfo", res.data);
          _this.userInfo = res.data;
        } else {
          console.log(res);
        }
      });
    },
    pay() {
      var _this = this;
      var data = {
        money: _this.money,
        pay_type: "account_pay",
      };
      _this.$toast.loading({
        message: "请稍等...",
        forbidClick: true,
        duration: 0,
      });
      addOp("/pay_order", data).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          _this.jsApiParameters = res.data;
          _this.callpay();
          // _this.payTypeShow = false;
        } else {
          _this.$toast.fail(res.data.error);
        }
      });
    },
    //支付
    jsApiCall() {
      var _this = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        _this.jsApiParameters,
        function (res) {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            alert("充值成功！");
            _this.$router.go(-1);
          } else if (res.err_msg === "get_brand_wcpay_request:fail") {
            alert("支付失败！请重试！");
          }
        }
      );
    },
    callpay() {
      var _this = this;
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            _this.jsApiCall,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", _this.jsApiCall);
          document.attachEvent("onWeixinJSBridgeReady", _this.jsApiCall);
        }
      } else {
        _this.jsApiCall();
      }
    },
  },
};
</script>

<style>
</style>